import { api } from '../api'

export const tokenexApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTokenexConfig: builder.query({
      query: ({ origin, type, campaignId }) =>
        `/token/tokenex?type=${type}&origin=${origin}&campaignId=${campaignId}`,
    }),
  }),
})

export const {
  endpoints: { getTokenexConfig },
  useGetTokenexConfigQuery,
} = tokenexApi
